import React, { forwardRef } from 'react';
import { Box, Divider, Grid, Table, TableBody, TableCell, TableFooter, TableHead, TableRow, Typography } from '@mui/material';

import currency from 'utils/currency';
import dateTime from 'utils/datetime';

export default forwardRef(({ payload }, ref) => {
  return (
    <div style={{ position: "absolute", top: -1000, zIndex: -999999 }}>
      <Box
        ref={ref}
        sx={{ width: '340px', padding: '15px', backgroundColor: '#fff', color: "#000" }}>
        <Typography variant="subtitle2" gutterBottom component="div" sx={{ textAlign: 'center', fontWeight: 'bold', mb: '15px' }}>
          နိုင် ငွေလဲဆိုင်
        </Typography>
        <Typography variant="subtitle1" gutterBottom component="div" sx={{ textAlign: 'center', fontWeight: 'bold' }}>
          BUY
        </Typography>
        <Grid container sx={{ justifyContent: 'center' }}>
          <Grid item fontSize="13px">
            <Typography variant="span">ID:&nbsp;</Typography>
            <Typography variant="span" fontWeight="bold">{payload?.id}</Typography>
          </Grid>
          <Divider orientation="vertical" sx={{ margin: '0px 8px', borderStyle: 'dashed', borderColor: '#B4B4B4' }} flexItem />
          <Grid fontSize="13px">
            <Typography variant="span">Date:&nbsp;</Typography>
            <Typography variant="span" fontWeight="bold">{dateTime.format(payload?.created_at)}</Typography>
          </Grid>
        </Grid>
        <Divider sx={{ marginTop: '16px ', borderBottom: '2px solid #bbb' }} />
        <Table
          sx={{
            'thead tr th': { borderBottom: '2px solid #bbb', color: "#000", p: '9px 10px', fontSize: '12px' },
            'tbody tr td': { p: '8px 10px', color: "#000", fontSize: '10px' },
            'tfoot tr td': { borderTop: '2px solid #bbb', color: "#040404", p: '10px 10px', fontSize: '13 px', borderBottom: 'none', backgroundColor: '#f5f5f5', fontWeight: "bold" },
          }}>
          <TableHead>
            <TableRow>
              <TableCell>#</TableCell>
              <TableCell>Currency</TableCell>
              <TableCell>Qty</TableCell>
              <TableCell>Rate</TableCell>
              <TableCell>Amount</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {payload?.sub_transactions?.map(({ id, bought_quantity, bought_amount, sold_amount, bought_capital, sold_capital }, index) => (
              <TableRow key={id}>
                <TableCell>{index + 1}</TableCell>
                <TableCell>{bought_capital.figure.code}</TableCell>
                <TableCell sx={{ textAlign: "right" }}>{bought_quantity}</TableCell>
                <TableCell sx={{ textAlign: "right" }}>{
                  currency.calculateExchnageRate({
                    boughtCurrency: bought_capital.figure.currency,
                    soldCurrency: sold_capital.figure.currency,
                    boughtAmount: bought_amount,
                    soldAmount: sold_amount,
                    splitter: `|`,
                  })
                }</TableCell>
                <TableCell sx={{ textAlign: "right" }}>{currency.format(sold_amount, 2)}</TableCell></TableRow>
            ))}

          </TableBody>
          <TableFooter>
            <TableRow>
              <TableCell colSpan={4} >Total ({payload?.sold_currency})</TableCell>
              <TableCell sx={{ textAlign: "right" }}>{currency.format(payload?.total_sold_amount, 2)}</TableCell>
            </TableRow>
          </TableFooter>
        </Table>
        <Box sx={{ height: '160px' }}>
        </Box>
      </Box>
    </div>
  );
});;
